import React, { useRef, useState } from "react";
import {
  BLOCK_TABLE,
  BLOCK_TABLE_CELL,
  BLOCK_TABLE_PRE,
  BLOCK_TABLE_ROW,
  BLOCK_TABLE_SUF,
  BLOCK_TABLE_WRAP,
} from "./types";
// import './table.less';
import { ReactEditor, useSelected, useSlate } from "slate-react";
import { getNodeDeserializer } from "@udecode/slate-plugins";

import { TableSelectProvider, useTableSelect } from "./table-select-context";
import clsx from "clsx";
import { Transforms } from "slate";
import { onTableKeyDown } from "./on-table-keydown";
import BaseElement from "../BaseElement";

export const MAX_TABLE_COLS = 7;
export const MAX_TABLE_ROWS = 20;

export const renderElementTable = (params) => {
  return ({ attributes, children, element }) => {
    if (element.type === BLOCK_TABLE_WRAP) {
      return (
        <TableWrap
          attributes={attributes}
          element={element}
          children={children}
          {...params}
        />
      );
    } else if (
      element.type === BLOCK_TABLE_PRE ||
      element.type === BLOCK_TABLE_SUF
    ) {
      return (
        <TableTool
          attributes={attributes}
          element={element}
          children={children}
        />
      );
    } else if (element.type === BLOCK_TABLE) {
      return (
        <Table attributes={attributes} element={element} children={children} />
      );
    } else if (element.type === BLOCK_TABLE_ROW) {
      return <tr {...attributes}>{children}</tr>;
    } else if (element.type === BLOCK_TABLE_CELL) {
      return (
        <TableCell
          attributes={attributes}
          element={element}
          children={children}
        />
      );
    }
  };
};

export function deserializeTable(options) {
  const type = "table";

  return {
    element: [
      ...getNodeDeserializer({
        type: BLOCK_TABLE,
        rules: [{ nodeNames: ["TABLE"] }],
        node: (el) => {
          // const { type: variableType, id, participant, apiname } = el.dataset;
          const isRow = el.nodeName === "TR";
          const isCell = el.nodeName === "TD";

          return {
            type: BLOCK_TABLE,
            tableBackgroundColor:
              el.style.background || el.style.backgroundColor,
            fontSize: el.style.fontSize,
          };
        },
      }),
      ...getNodeDeserializer({
        type: BLOCK_TABLE_ROW,
        rules: [{ nodeNames: ["TR"] }],
        node: (el) => {
          // const { type: variableType, id, participant, apiname } = el.dataset;
          const isRow = el.nodeName === "TR";
          const isCell = el.nodeName === "TD";

          return {
            type: BLOCK_TABLE_ROW,
            rowBackgroundColor: el.style.background || el.style.backgroundColor,
            fontSize: el.style.fontSize,
          };
        },
      }),
      ...getNodeDeserializer({
        type: BLOCK_TABLE_CELL,
        rules: [{ nodeNames: ["TD"] }],
        node: (el) => {
          // const { type: variableType, id, participant, apiname } = el.dataset;
          const isRow = el.nodeName === "TR";
          const isCell = el.nodeName === "TD";

          return {
            type: BLOCK_TABLE_CELL,
            cellBackgroundColor:
              el.style.background || el.style.backgroundColor,
            fontSize: el.style.fontSize,
          };
        },
      }),
    ],
  };
}

// TODO: add table deserializer
export const TablePlugin = (params) => ({
  renderElement: renderElementTable(params),
  onKeyDown: onTableKeyDown,
  deserialize: deserializeTable(),
  // inlineTypes: [BLOCK_TABLE_WRAP, BLOCK_TABLE_PRE, BLOCK_TABLE_SUF, BLOCK_TABLE, BLOCK_TABLE_ROW, BLOCK_TABLE_CELL]
});

const TableTool = ({ attributes, children, element }) => {
  return (
    <span
      className="table-element-tool"
      contentEditable={false}
      style={{ userSelect: "none" }}
      {...attributes}
    >
      {children}
    </span>
  );
};

const TableWrap = ({ attributes, children, element, ...props }) => {
  return (
    <BaseElement element={element} type="table" {...props} {...attributes}>
      {() => children}
      {/* <div {...attributes} className="table-element-wrap"> */}

      {/* </div> */}
    </BaseElement>
  );
};

const Table = ({ attributes, children, element }) => {
  const col = element.col;
  const elementWidth = 625;
  const widths = element.widths || [];
  const total = Array(col)
    .fill("")
    .reduce(
      (prev, curr, idx) =>
        prev + (widths[idx] || Math.max(elementWidth / col, 100)),
      0
    );

  let editor = useSlate();

  return (
    <table
      style={{ backgroundColor: element.backgroundColor }}
      className={clsx("table-element")}
      {...attributes}
    >
      <colgroup contentEditable={false}>
        {Array(col)
          .fill("")
          .map((v, i) => (
            <col key={i} width={widths[i] || elementWidth / col} />
          ))}
      </colgroup>
      <tbody>{children}</tbody>
    </table>
  );
};

const TableCell = ({ attributes, children, element }) => {
  let editor = useSlate();
  let path = ReactEditor.findPath(editor, element);
  const x = path[path.length - 2];
  const y = path[path.length - 1];

  let { select, selected, startSelect, moveSelect, stopSelect, selectRange } =
    useTableSelect();

  const handleMouseDown = () => {
    if (!select) {
      startSelect(x, y);
    }
  };

  const handleMouseEnter = () => {
    moveSelect(x, y);
  };

  const handleMouseUp = () => {
    stopSelect(x, y);
  };

  const inSelect =
    x >= selectRange.x1 &&
    x <= selectRange.x2 &&
    y >= selectRange.y1 &&
    y <= selectRange.y2;

  const { rowspan, colSpan } = element;

  return (
    <td
      {...attributes}
      className={clsx({ selected: inSelect && selected })}
      style={{ background: element.cellBackgroundColor }}
      onMouseDown={handleMouseDown}
      onMouseEnter={handleMouseEnter}
      onMouseUp={handleMouseUp}
      rowSpan={rowspan || 1}
      colSpan={colSpan || 1}
    >
      {children}
    </td>
  );
};
